module.exports = __webpack_public_path__ + "img/logo.f50bdf5d.png";